/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  useCallback,
} from 'react';
import {
  Dialog,
  IconButton,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import styled from 'styled-components';
import { setOpen, setAvatarImage, skipAddProfilePicture } from 'models/firstTimeProfilePictureModal';
import { useDispatch, useSelector, batch } from 'react-redux';
import ProfileAvatarSection from 'components/ProfileAvatarSection';
import toBase64 from 'models/helpers/toBase64';
import GreetingTitle from './GreetingTitle';
import UploadCallToAction from './UploadCallToAction';
import SkipForNowButton from './SkipForNowButton';
import SavePictureButton from './SavePictureButton';

const StyledDialog = styled(Dialog)`
  text-align: center;
`;

const StyledDialogActions = styled(DialogActions)`
  flex-direction: column;
  margin-bottom: 16px;
`;

const StyledProfileAvatarSection = styled(ProfileAvatarSection)`
  margin: 32px 16px 16px;
`;

const CloseIconButton = styled(IconButton)`
  position: absolute;
  top: 16px;
  right: 16px;
`;

const FirstTimeProfilePictureModal = () => {
  const dispatch = useDispatch();
  const open = useSelector((s) => (s as any).firstTimeProfilePictureModal.open);

  const onClose = useCallback(() => {
    dispatch(setOpen(false));
  }, [dispatch]);

  const onSave = useCallback(() => {
    dispatch(setOpen(false));
  }, [dispatch]);

  const onSkip = useCallback(() => {
    batch(() => {
      dispatch(setOpen(false));
      dispatch(skipAddProfilePicture());
    });
  }, [dispatch]);

  const avatar = useSelector((s) => (s as any).firstTimeProfilePictureModal.avatarImage);

  const onAvatarChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const imageFile = event.target.files[0];
    const encodedImage = await toBase64(imageFile);
    dispatch(setAvatarImage(encodedImage.toString()));
  };

  return (
    <StyledDialog
      open={open}
      fullWidth
      onClose={onClose}
    >
      <DialogContent>
        <GreetingTitle />
        <CloseIconButton onClick={onClose}>
          <CloseIcon />
        </CloseIconButton>
        <UploadCallToAction />
        <StyledProfileAvatarSection avatar={avatar} onAvatarChange={onAvatarChange} />
        <StyledDialogActions>
          <SavePictureButton onSave={onSave} />
          <SkipForNowButton onSkip={onSkip} />
        </StyledDialogActions>
      </DialogContent>
    </StyledDialog>
  );
};

export default FirstTimeProfilePictureModal;
